import React from 'react';
import {UserAvatar} from '@components/util/UserAvatar';
import {Call} from '@store/call-card/Call';
import Button from '@material-ui/core/Button';
import './CallsListItem.sass';
import './CallsListItem.mobile.sass';
import CrmSyncCloudIcon from 'components/pure/call-card/sync-crm/CrmSyncCloudIcon';
import User from 'records/User';
import {CallActivity} from '@components/call-card/search/CallActivity';
import CoachingQuickActions from 'components/pure/call-card/coaching-quick-actions/CoachingQuickActions';
import FileUploadCallDetailsActions from 'actions/files/FileUploadCallDetailsActions';
import {browserHistory} from 'react-router';
import CallActionDialogs from '@components/call-card/CallActionDialogs';
import LibraryTagDisplay from 'components/pure/call-card/LibraryTagDisplay';
import {LibraryId} from '@store/@types/records/Library';
import hasFlag from 'utils/hasFlag';
import {featureFlags} from 'utils/const';

interface CallsListItemProps {
  call: Call;
  supportsCrmSync: boolean;
  sessionUser: User;
  libraryId?: LibraryId;
}

export const CallsListItem: React.FC<CallsListItemProps> = ({
  call,
  supportsCrmSync,
  sessionUser,
  libraryId,
}) => {
  return (
    <div
      onClick={() => browserHistory.push({pathname: `/call/${call.id}`, query: {libraryId}})}
      className="calls-list-item">
      <UserAvatar user={call.caller} />
      <div className="coaching-section">
        <div className="caller-name">
          <UserAvatar user={call.caller} />
          {call.caller.getFullName()}
        </div>
        <CoachingQuickActions
          fileUploadId={call.id}
          isCoachingProvided={call.coachingProvided}
          isCoachingRequested={call.coachMe}
          caller={call.caller}
        />
      </div>
      <div className="template-info">
        <div className="call-title">
          {supportsCrmSync && (
            <CrmSyncCloudIcon
              crmLink={call.crmLink}
              callId={call.id}
              authUser={sessionUser}
              caller={call.caller}
            />
          )}
          <div
            className="template-line line-one"
            dangerouslySetInnerHTML={{__html: call.template.lineOne}}></div>
        </div>
        <div
          className="template-line line-two"
          // &nbsp here to keep these lines around for layout purposes, even if they're empty
          dangerouslySetInnerHTML={{__html: call.template.lineTwo + '&nbsp'}}></div>
        <div
          className="template-line line-three"
          dangerouslySetInnerHTML={{__html: call.template.lineThree + '&nbsp'}}></div>
      </div>
      <div className="call-info">
        <CallActivity call={call} />
        <LibraryTagDisplay libraryId={libraryId} fileUploadId={call.id} />
        <div className="call-details">
          {hasFlag(featureFlags.downloadCall) && (
            <Button
              onClick={e => {
                e.stopPropagation();
                window.open(
                  `/api/internal/calls/${call.id}/download`,
                  '_blank',
                  'noopener,noreferrer'
                );
              }}
              size="small"
              variant="outlined">
              Download Call
            </Button>
          )}
          <Button
            onClick={e => {
              e.stopPropagation();
              return FileUploadCallDetailsActions.showCallDetails(call.id);
            }}
            size="small"
            variant="outlined">
            Call Details
          </Button>
        </div>
      </div>
      <CallActionDialogs call={call} />
    </div>
  );
};
